import styled, { css } from 'styled-components';

import { hoverWash } from '../../theme/mixins';
import { GAUGE_GLOW_OPACITY, HOME, gaugeGlowLayer } from '../../theme/tokens';

/** The card's corner radius (Home's score gauge card). */
const RADIUS_PX = 22;

/**
 * The card: Home's score gauge card base and hairline, its radius, and, when the card is a control, the shared hover
 * wash and a pointer cursor. A stacking context of its own, so the glow can sit behind everything the card holds; it clips the glow to the
 * card's rounded shape.
 */
export const Surface = styled.div<{ $interactive: boolean }>`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  box-sizing: border-box;
  background: ${HOME.gaugeBase};
  border: 1px solid ${HOME.gaugeBorder};
  border-radius: ${RADIUS_PX}px;

  ${(p) =>
    p.$interactive &&
    css`
      cursor: pointer;
      ${hoverWash}
    `}
`;

/**
 * The glow: the stop list handed in, from the top-left corner to the bottom-right, at the gauge glow's opacity. Behind
 * the card's content (below it in the card's stacking context), and never in the way of a pointer.
 */
export const Glow = styled.span<{ $glow: string }>`
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background: ${(p) => gaugeGlowLayer(p.$glow)};
  opacity: ${GAUGE_GLOW_OPACITY};

  /* Light theme: painted stronger over the white base, so the glow starts from a deeper tint of its colour (the user,
     2026-10-21). */
  :root[data-ows-theme='light'] & {
    opacity: 0.32;
  }
`;
